import * as echarts from 'echarts';

class echartPieChartController implements angular.IOnInit, angular.IOnChanges, angular.IPostLink {
  private MIN_SCREEN_WIDTH = 400;

  public chartValues: { name: string, total: number }[];
  public chartColours: string[];
  public chartClass: string;

  public showLabels: boolean;
  public showIndicators: boolean;

  private overallTotal: number = 0;
  private eChart: any;

  public displayCurrency: string;

  /** @ngInject */
  constructor(private $scope: angular.IScope) { }

  $onInit(): void {
    this.showLabels = this.showLabels === undefined ? true : this.showLabels;
    this.showIndicators = !!this.showIndicators; // Default is false (So this works)

    if (this.chartValues) {
      this.calculateTotal();
    }

    this.resizeOnChange = this.resizeOnChange.bind(this);
  }

  $onChanges(onChangesObj: angular.IOnChangesObject): void {
    if (onChangesObj.chartValues &&
      onChangesObj.chartValues.currentValue) {
      this.calculateTotal();

      if (this.eChart) {
        this.updateChart();
      }
    }

    if (onChangesObj.chartColours &&
      onChangesObj.chartColours.currentValue) {
      if (this.eChart) {
        this.updateChart();
      }
    }
  }

  $postLink(): void {

    let that = this;
    this.eChart = echarts.init(this.$scope['container'][0]);

    // 'this.eChart.getDom().parentElement.parentElement' Gets the parent above the wrapper :|
    this.$scope.$watch(() => this.eChart.getDom().parentElement.parentElement.clientWidth, this.resizeOnChange)
    this.$scope.$watch(() => this.eChart.getDom().parentElement.parentElement.clientHeight, this.resizeOnChange)

    this.eChart.setOption({
      tooltip: {
        trigger: 'item',
        formatter: "{b}: {d}%"
        // example of a custom format
        // function (params){
        //   return  `${params.data.name} \n \n ${params.data.value.toLocaleString('en-EN', {style: 'currency', currency: that.displayCurrency})}`;
        // }
      },
      grid: {
        containLabel: true
      },

      series: {
        type: 'pie',
        radius: ['50%', '70%'],
        // center: ['50%', '50%'],
        avoidLabelOverlap: true,
        labelLine: {
          normal: {
            show: window.screen.width > this.MIN_SCREEN_WIDTH ? this.showLabels : false
          }
        },
        label: {
          normal: {
            show: window.screen.width > this.MIN_SCREEN_WIDTH ? this.showLabels : false,
            fontSize: (window.screen.width > 1920 ? 24 : 12),
            // position: 'center',
            // formatter : function(params){
            //     return ` ${that.overallTotal.toLocaleString('en-EN', {style: 'currency', currency: that.displayCurrency})} `;
            // }
          },
          // Example if we want to display the label in the middle of the doughnut chart
          // emphasis: {
          //     show: false, //window.screen.width > this.MIN_SCREEN_WIDTH ? this.showLabels : false,
          //     textStyle: {
          //         fontSize: (window.screen.width > 1920 ? 24 : 12),
          //         fontWeight: 'bold'
          //     },
          //     formatter:  function (params){
          //       console.log("params",params)
          //       return  params.data.name + "\n" + params.data.value.toLocaleString('en-EN', {style: 'currency', currency: that.displayCurrency});
          //     }

          // }
        },

        // label: {
        //   normal: {
        //     show: window.screen.width > this.MIN_SCREEN_WIDTH ? this.showLabels : false,
        //     fontSize: (window.screen.width > 1920 ? 24 : 12)
        //   }
        // }
      }
    });

    if (this.chartValues) {
      this.updateChart();
    }
  }

  private resizeOnChange(newValue, oldValue) {
    return newValue !== 0 ? this.eChart.resize() : null
  }

  private calculateTotal() {
    this.overallTotal = this.chartValues.reduce((total, current) => total + current.total, 0);
  }

  private updateChart() {
    const updateOptions = {
      series: {
        data: this.chartValues.filter(value => value.total != 0).map((value, index) => {
          const chartData = {
            name: value.name,
            value: value.total,
            itemStyle: undefined
          };

          if (!!this.chartColours) {
            chartData.itemStyle = {
              normal: {
                // color: this.chartColours[AssetClassNameArray.indexOf(value.name)]
                color: this.chartColours[index]
              }
            }
          }
          return chartData;
        })
      }
    }
    this.eChart.setOption(updateOptions);
  }
}

export const echartPieChart: angular.IComponentOptions = {
  controller: echartPieChartController,
  template: require('./echartPieChart.component.html'),
  bindings: {
    chartValues: '<',
    chartColours: '<',
    showLabels: '<',
    showIndicators: '<',
    displayCurrency: '<',
    chartClass: '='
  }
}



// WEBPACK FOOTER //
// ./src/app/common/echartPieChart.component.ts